import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LineNotesIcon from 'components/Luxkit/Icons/line/LineNotesIcon'
import { CuratedBaseItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedBaseItemSelection'
import CuratedItemSelection from 'tripPlanner/components/CuratedItemSelection/CuratedItemSelection'
import { CuratedTripSection } from 'tripPlanner/types/common'

const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${rem(8)};
  gap: ${rem(10)};
  background-color: ${props => props.theme.palette.neutral.default.six};
  width: ${rem(36)};
  height: ${rem(36)};
`

interface Props {
  section: CuratedTripSection
  selectedItems: Set<string>
  onSelect: (id: string) => void
}
export function CuratedSectionSelection({
  section,
  selectedItems,
  onSelect,
}: Props) {
  const { sectionHeader, items } = section

  const sectionId = sectionHeader?.id

  return (
    <div id={sectionId}>
      {sectionHeader && (
        <CuratedBaseItemSelection
          title={'Day ' + sectionHeader?.startDay + ' - ' + sectionHeader.title}
          type={sectionHeader.type}
          onSelect={() => onSelect(sectionHeader.id)}
          isSelected={selectedItems.has(sectionHeader.id)}
          image={
            <ImageContainer>
              <LineNotesIcon />
            </ImageContainer>
          }
        />
      )}

      {items.map((item) => (
        <CuratedItemSelection
          key={item.id}
          item={item}
          onSelect={() => onSelect(item.id)}
          isSelected={selectedItems.has(item.id)}
        />
      ))}
    </div>
  )
}
